import httpService from "./http.service";

const requestedBytes = 1024 * 1024 * 1024;

function errorHandler(e) {
  console.log(e)
}

function GetRecordingFilePath(id) {
  return new Promise ((resolve, reject) => {
    navigator.webkitPersistentStorage.requestQuota(requestedBytes
      , function(grantedBytes) {
        window.webkitRequestFileSystem(window.PERSISTENT
          , grantedBytes
          , function (fs) {
            const url = fs.root.toURL();
            const localPath = url + `alchemymachines/${id}.mp3`;
            
            window.webkitResolveLocalFileSystemURL(localPath
              , function(file) {
                file.file((blob) => {
                  resolve(URL.createObjectURL(blob));
                });
              }, function(err) {
                reject(err);
              })
          }
          , errorHandler);
      }, errorHandler);
  })
}

function SaveRecordingFile (blob, id) {
  return new Promise((resolve) => {
    
    navigator.webkitPersistentStorage.requestQuota(requestedBytes
      , function(grantedBytes) {
        window.webkitRequestFileSystem(window.PERSISTENT
          , grantedBytes
          , writeFile
          , errorHandler);
      }, errorHandler);
    
    function writeFile(fs) {
      fs.root.getDirectory('alchemymachines', {
        create: true
      }, function(dirEntry) {
      }, errorHandler);
      
      fs.root.getFile(`alchemymachines/${id}.mp3`, {
        create: true,
        exclusive: true
      }, function(fileEntry) {
        fileEntry.createWriter(function(fileWriter) {
          fileWriter.onwriteend = function() {
            const url = fs.root.toURL();
            const localPath = url + `alchemymachines/${id}.mp3`;
            
            window.webkitResolveLocalFileSystemURL(localPath
              , function(file) {
                file.file((blob) => {
                  resolve(URL.createObjectURL(blob));
                });
              })
          };
          fileWriter.onerror = errorHandler;
          fileWriter.write(blob);
        }, errorHandler);
      }, errorHandler);
    }
  });
}

function getRootNodes() {
  return httpService.get('recordings-api/file-management/nodes');
}

function getChildNodes(node_id) {
  return httpService.get(`recordings-api/file-management/nodes/${node_id}`);
}

function createNewRootFolder(folderName) {
  const data = {
    node_name: folderName
  };
  
  return httpService.post('recordings-api/file-management/nodes', data);
}

function moveRecording(recordingId, node_id) {
  const data = {
    node_id: node_id,
    recordings_ids: [recordingId]
  };
  
  return httpService.put(`recordings-api/file-management/recordings/move`, data);
}

function archiveRecording(recordingId) {
  const data = {
    recordings_ids: [recordingId]
  };
  
  return httpService.put(`recordings-api/file-management/recordings/archive`, data);
}

export default {
  GetRecordingFilePath,
  SaveRecordingFile,
  getRootNodes,
  getChildNodes,
  moveRecording,
  archiveRecording,
  createNewRootFolder,
}

